import { AppDispatch } from "app/store";
import {
  initialAsync,
  selectPageState,
  selectReCaptchaSiteKey,
} from "features/signup";
import React, { useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import SignupConfirm from "./SignupConfirm";
import SignupInput from "./SignupInput";

const SignupPage: React.FC<{ completeTo: string }> = ({
  completeTo,
}): JSX.Element => {
  const dispatch: AppDispatch = useDispatch();
  const state = useSelector(selectPageState);
  const reCaptchaKey = useSelector(selectReCaptchaSiteKey);

  useEffect(() => {
    dispatch(initialAsync());
  }, [dispatch]);

  return reCaptchaKey !== "" ? (
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey} language="en">
      {getComponent(state, completeTo)}
    </GoogleReCaptchaProvider>
  ) : (
    <div />
  );
};

// 現在のサインアップ画面の状態に応じて表示Componentを出し分ける
const getComponent = (
  state: "input" | "confirm" | "complete",
  completeTo: string
) => {
  switch (state) {
    case "input":
      return <SignupInput />;
    case "confirm":
      return <SignupConfirm />;
    case "complete":
      return <Navigate to={completeTo} replace />;
    default:
      return <div />;
  }
};

export default SignupPage;
